import { render, staticRenderFns } from "./ProductDlgLinks.vue?vue&type=template&id=607880d4&scoped=true&"
import script from "./ProductDlgLinks.vue?vue&type=script&lang=ts&"
export * from "./ProductDlgLinks.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDlgLinks.vue?vue&type=style&index=0&id=607880d4&scoped=true&lang=scss&"
import style1 from "./ProductDlgLinks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607880d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSubheader,VTextField})
